import AbstractWizardStep from "../AbstractWizardStep.js";

/**
 * `AuthenticationStep` is the first step of import process.
 * It triggers the authentication flow on submit.
 * Its purpose is to display potential error messages that
 * could occur during authentication inside the wizard.
 */
export default class AuthenticationStep extends AbstractWizardStep {
	getRenderable() {
		// The parent class requires an implementation of this method.
		// This step is only used to trigger the authentication flow and
		// to display errors. Therefore, nothing needs to be rendered.
		return () => {};
	}

	_shouldSubmitOnStart() {
		return true;
	}

	_isCompleted() {
		return true;
	}
}
